const json_fi = {
  'logo.byline': 'MTV Sisäpiiri',

  'user.role.superuser': 'Pääkäyttäjä',
  'user.role.salesmanager': 'Myyntijohtaja',
  'user.role.regionmanager': 'Aluepäällikkö',
  'user.role.teamlead': 'Tiiminvetäjä',
  'user.role.user': 'Myyjä',
  'user.role.assistant': 'Assistentti',

  'navi.root': 'Sisäpiiri',
  'navi.products': 'Tuotteet',
  'navi.admin': 'Admin',
  'navi.sportsCalendar': 'Urheilukalenteri',
  'navi.prizes': 'Palkinto-ohjelma',
  'navi.profile': 'Omat tiedot',
  'navi.noname': 'Tiedot',
  'navi.logout': 'Kirjaudu ulos',
  'navi.back': 'Takaisin',

  'search': 'HAE',
  'search.all': 'Kaikki',
  'search.hint': 'Suodata sisältöä',
  'filters.target': 'Kohdenna julkaisu',
  'filters.add': 'Lisää uusi kohderyhmä',
  'filters.tags': 'Valitse avainsanat',
  'targeting.channel': 'Valitse operaattori',
  'targeting.role': 'Valitse rooli',

  'login.header': 'Kirjaudu sisään',
  login: 'Kirjaudu',
  logout: 'Kirjaudu ulos',

  'root.header': 'Tervehdys',
  'root.admin': 'Admin',
  'prizes.header': 'Palkinto-ohjelma',
  'rules.header': 'Palkinto-ohjelman säännöt',
  'privacy.header': 'Sisäpiirin tietosuoja',
  'products.header': 'Tuotteet',
  'news.header': 'Ajankohtaista',
  'inner-circle.header': 'Sisäpiiritieto',
  'inner-circle': 'Sisäpiiri',

  'team.score': 'Tiimisi pistetilanne',
  'team.score.total': 'Yhteensä',
  'team.top': 'Kauden parhaat tiimit',
  'team.top.sellers': 'Tiimin parhaat myyjät',
  'region.top': 'Parhaat paikkakunnat',
  'region.top.empty': 'Ei vielä parhaita paikkakuntia',
  'region.top.score': 'pisteet',
  'region.top.sales': 'myynnit',
  'region.top.people': 'myyjiä',
  'sellers.top': 'Kauden parhaat myyjät',
  'team.position.national': 'Tiimisi on valtakunnallisesti sijalla',
  'latest.sales': 'Viimeisimmät myynnit',
  'my.sales': 'Omat myynnit',
  score: 'pistettä',
  'score.short': 'p',
  'score.now': 'Pistetilanteesi juuri nyt!',
  'prizes.all': 'Kaikki palkinnot',
  'rules.all': 'Kaikki säännöt',
  'news.all': 'Kaikki artikkelit',
  'news.prev': 'Aikaisemmat artikkelit',
  'inner-circle.all': 'Kaikki ilmoitukset',
  'inner-circle.prev': 'Aikaisemmat ilmoitukset',
  'campaign-time': 'Palkinto-ohjelmat',
  'shop.open': 'Palkintokaupan aukiolo',
  prize: 'Palkinto',
  prizes: 'Palkinnot',
  scores: 'Pisteenkeruu',
  'score.unit': 'Pisteluokka',
  packages: 'Tuotteet',

  'form.user.label': 'Käyttäjätunnuksesi (sähköpostiosoite)',
  'form.user.placeholder': 'sähköpostiosoite',
  'form.pass.label': 'Salasana',
  'form.pass.placeholder': '********',
  'form.pass.forgot': 'Unohtuiko salasanasi?',

  'some.facebook': 'C More Facebook',
  'some.twitter': 'C More Twitter',

  'action.cancel': 'Peruuta',
  'action.ok': 'Ok',
  'action.confirm': 'Kyllä',
  'action.submit': 'Tallenna',
  'action.save': 'Tallenna muutokset',
  'action.update': 'Päivitä',
  'action.join': 'Liity mukaan',
  'action.delete': 'Poista',
  'action.edit': 'Muokkaa',
  'action.invite.user': 'Kutsu käyttäjä',
  'action.save.prize': 'Tallenna palkinto',
  'action.sale.add': 'Ilmoita myynti',
  'action.print.users': 'Tulosta käyttäjätiedot',
  'action.print.history': 'Tulosta myyntihistoria',
  'action.print.history.own': 'Tulosta oma myyntihistoria',
  'action.package.edit': 'Muokkaa tuotteita',
  'action.show.more': 'Näytä lisää',
  'action.close': 'Sulje',
  'scores.edit': 'Muokkaa pisteitä',

  'admin.users': 'Käyttäjähallinta',
  'admin.to.users': 'Käyttäjähallintaan',
  'admin.users.created.list': 'Takaisin käyttäjähallintaan',
  'admin.transfer.user': 'Siirrä käyttäjä',
  'admin.delete.user': 'Poista käyttäjä',
  'admin.delete.team': 'Poista tiimi',
  'admin.delete.region': 'Poista alue',
  'admin.delete.channel': 'Poista myyntikanava',
  'admin.add.user': 'Lisää käyttäjä',
  'admin.user.invite': 'Käyttäjä saa sähköpostiin kutsun, jolla hän liittyy valitsemaasi tiimiin.',
  'admin.team.admin': 'Tiimiesimies näkyy palvelussa, kun hän on rekisteröitynyt kutsussa olevasta linkistä.',
  'admin.team.user': 'Käyttäjä näkyy palvelussa, kun hän on rekisteröitynyt kutsussa olevasta linkistä.',
  'admin.add.channel': 'Lisää jälleenmyyjä',
  'admin.add.region': 'Lisää alue',
  'admin.add.team': 'Lisää tiimi',
  'admin.add.sales.person': 'Lisää myyjä',
  'admin.add.assistant': 'Lisää assistentti',
  'admin.promote': 'Aseta hallitsijaksi',
  'admin.confirm.delete': 'Haluatko varmasti poistaa käyttäjän',
  'admin.login': 'Kirjaudu käyttäjänä',
  'admin.confirm.login': 'Haluatko varmasti kirjautua sisään käyttäjänä',
  'admin.copy': 'Kopioi leikepöydälle',
  'admin.change.role': 'Siirrä tai muuta roolia',
  'order.cancellation': 'peruutuksen esto',

  password: 'Salasana',
  'password.old': 'Vanha salasana',
  'password.new': 'Uusi salasana',
  'password.new.again': 'Uusi salasana uudelleen',
  'password.again': 'Salasana uudelleen',
  'password.update': 'Päivitä salasanasi',
  'password.forgot': 'Unohditko salasanasi?',
  'password.restore': 'Palauta salasana',
  'password.change': 'Vaihda salasana',

  name: 'Nimi',
  'sales.person': 'Myyjä',
  channel: 'Jälleenmyyjä',
  'channel.all': 'Kaikki',
  region: 'Alue',
  'region.none': 'Ei aluetta',
  package: 'Paketti',
  product: 'Tuote',
  type: 'Tyyppi',
  joined: 'Liittynyt',
  user: 'Käyttäjä',
  team: 'Tiimi',
  rights: 'Oikeudet',
  role: 'Rooli',
  date: 'Pvm',
  amount: 'Kpl',
  id: 'Tunniste',
  category: 'Kategoria',
  header: 'Otsikko',
  description: 'Kuvaus',
  email: 'Sähköpostiosoite',

  'package.empty': 'Ei vielä yhtään tuotetta.',
  'package.edit': 'Muokkaa tuotteita',

  'user.empty': 'Ei vielä yhtään käyttäjää.',

  'campaign.end.alert':
    'Palkinto-ohjelma on päättynyt, nyt päästään palkintoihin!<br />Myyntien tarkistus on nyt käynnissä. Palaamme palkitsemiseen 14.6. jälkeen.',
  'campaign.prize-shop.ended.alert': 'Kampanja on päättynyt. Tervetuloa mukaan taas ensi kerralla!',
  'campaign.empty': 'Ei vielä yhtään palkinto-ohjelmaa',
  'campaign.add': 'Lisää palkinto-ohjelma',
  'campaign.channel': 'Valitse kumppani',
  'campaign.create': 'Luo palkinto-ohjelma',
  'campaigns.edit': 'Muokkaa palkinto-ohjelmia',
  'campaign.edit': 'Muokkaa palkinto-ohjelmaa',
  'campaign.starts': 'Kampanja alkaa',
  'campaign.ends': 'Kampanja päättyy',
  'campaign.partner': 'Kumppani',
  'campaign.bonus': 'Bonuskerroin',
  'campaign.startDate': 'Alkamispäivämäärä',
  'campaign.endDate': 'Loppumispäivämäärä',
  'campaign.shop.endDate': 'Palkintokauppa sulkeutuu',
  'campaign.delete.confirm': 'Haluatko varmasti poistaa palkinto-ohjelman?',
  starts: 'Alkaa',
  ends: 'Päättyy',

  'transaction.delete': 'Poista myynti',
  'transaction.delete.confirm': 'Haluatko varmasti poistaa myynnin?',

  'prize.add': 'Lisää palkinto',
  'prize.edit': 'Muokkaa palkintoa',
  'prize.image.alt': 'Palkinto kuva',
  'prize.main.header': 'Kuulitko pääpalkinnosta?',
  'prize.almost.header': 'Seuraava palkintotaso',
  'prize.main.season.header': 'Kauden pääpalkinto',
  'prize.details': 'Lisätietoja',
  'prize.link.gogift': 'Lisätietoa palkintojen toimittajan sivuilta',
  'prize.bonus': 'Saamasi bonukset tiimisi myynneistä',
  'prize.bonus.score': 'pistettä!',

  'rules.add': 'Lisää säännöt',
  'rules.edit': 'Muokkaa sääntöjä',
  'rules.delete': 'Poista säännöt',
  'rules.create': 'Luo säännöt',
  'rules.publish': 'Julkaise säännöt',
  'rules.empty': 'Ei vielä yhtään sääntöjä.',
  'rules.delete.confirm': 'Haluatko varmasti poistaa säännöt?',
  'rules.created': 'Onnistui! Säännöt on nyt julkaistu.',
  'rules.created.view': 'Siirry katsomaan sääntöjä',
  'rules.created.list': 'Takaisin sääntölistaukseen',

  'news.add': 'Lisää artikkeli',
  'news.edit': 'Muokkaa artikkelia',
  'news.delete': 'Poista artikkeli',
  'news.create': 'Luo artikkeli',
  'news.publish': 'Julkaise artikkeli',
  'news.empty': 'Ei vielä yhtään artikkelia.',
  'news.delete.confirm': 'Haluatko varmasti poistaa artikkelin?',
  'news.created': 'Onnistui! Artikkelisi on nyt julkaistu.',
  'news.created.view': 'Siirry katsomaan artikkelia',
  'news.created.list': 'Takaisin artikkelilistaukseen',

  'inner-circle.add': 'Lisää ilmoitus',
  'inner-circle.edit': 'Muokkaa ilmoitusta',
  'inner-circle.delete': 'Poista ilmoitus',
  'inner-circle.create': 'Luo ilmoitus',
  'inner-circle.publish': 'Julkaise ilmoitus',
  'inner-circle.empty': 'Ei vielä yhtään ilmoitusta.',
  'inner-circle.delete.confirm': 'Haluatko varmasti poistaa ilmoituksen?',
  'inner-circle.created': 'Onnistui! Sisäpiiritieto-ilmoitus on nyt julkaistu.',
  'inner-circle.created.view': 'Siirry katsomaan ilmoitusta',
  'inner-circle.created.list': 'Takaisin ilmoituslistaukseen',

  'error.general': 'Äsh, Valitettavasti jokin meni pieleen. Tarkista verkkoyhteytesi ja yritä hetken päästä uudestaan.',
  'error.retry': 'Yritä uudelleen',

  'transaction.createdAt': 'Ilmoitettu',
  'transaction.date': 'Myyntipvm',

  'transaction.search.date.from': 'Myyntipvm alkaen',
  'transaction.search.date.to': 'Myyntipvm asti',
  'transaction.search.channel': 'Jälleenmyyjä',
  'transaction.search.region': 'Alue',
  'transaction.search.team': 'Tiimi',
  'transaction.search.person': 'Myyjä',
  'transaction.search.keyword': 'Hakutermi',
  'transaction.search.createdAt': 'Ilmoitettu',
  'transaction.search.date': 'Myyntipvm',
  'transaction.search.package': 'Paketti',
  'transaction.search.type': 'Tyyppi',
  'transaction.search.salesId': 'Tunniste',
  'transaction.search.count': 'Rivimäärä',
  'transaction.search.submit': 'Hae myynnit',

  'form.product-category.name.error': 'Syötä paketin nimi.',
  'form.product-category.description.error': 'Syötä paketin tilausvaihtoehdot.',
  'form.product-category.url.error': 'Syötä linkki lisätietoihin.',

  'form.sales-boost.score-modifier.error': 'Syötä kerroin pelkkinä numeroina.',
  'form.product-scores.score.error': 'Pisteet numeroina.',

  'form.content.category.error': 'Nimeä vielä artikkelin aihepiiri.',
  'form.content.channel.error': 'Valitse jälleenmyyjä, jolle ilmoitus julkaistaan.',
  'form.content.name.error': 'Tähän joku kuvaava otsikko.',
  'form.content.content.error': 'Hei, juttu unohtui!',
  'form.content.image.error':
    'Kuvan lisääminen ei onnistunut. Onhan kuva jpg-, tai png -muodossa, ja alle 20 megaa kooltaan?',
  'form.content.targetings.error': 'Valitse julkaisulle kohdennus: operaattori ja rooli',

  'form.login.error': 'Kirjautuminen epäonnistui.',
  'form.login.error.email': 'Käytä sähköpostiosoitetta, jonka kautta sait kutsun<br />C More Sisäpiiriin.',
  'form.login.error.password': 'Väärä salasana, yritä uudelleen.',

  'form.login.email.error': 'Kirjoita sähköpostiosoitteesi.',
  'form.login.password.error': 'Kirjoita vielä salasana.',

  'form.forgot-password.email.error': 'Kirjoita sähköpostiosoitteesi.',

  'form.prize.name.error': 'Tämä tieto tarvitaan.',
  'form.prize.type.error': 'Tämä tieto tarvitaan.',
  'form.prize.price.error': 'Syötä pisteet pelkkinä numeroina.',
  'form.prize.description.error': 'Tämä tieto tarvitaan.',
  'form.prize.vendor-url.error': 'Tämä tieto tarvitaan.',
  'form.prize.image.error': 'Kuvan lisääminen ei onnistunut.',

  'form.create-transaction.product-category.error': 'Valitse paketti.',
  'form.create-transaction.product.error': 'Valitse tuote.',
  'form.create-transaction.quantity.error': 'Kpl 1-10.',
  'form.create-transaction.date.error': 'Virheellinen päivämäärä.',

  'form.change-password.old-password.error': 'Kirjoita vanha salasanasi.',
  'form.change-password.new-password.error': 'Kirjoita uusi salasanasi.',
  'form.change-password.new-password-confirm.error': 'Kirjoita tähän uusi salasanasi uudelleen.',
  'form.change-password.new-password-equality.error': 'Salasanat eivät täsmää. Kokeile kirjoittaa uudelleen.',

  'form.reset-password.password.error': 'Kirjoita uusi salasanasi.',
  'form.reset-password.password-confirm.error': 'Kirjoita tähän uusi salasanasi uudelleen.',
  'form.reset-password.password-equality.error': 'Salasanat eivät täsmää. Kokeile kirjoittaa uudelleen.',

  'form.register.firstname.error': 'Kirjoita vielä etunimesi.',
  'form.register.lastname.error': 'Kirjoita vielä sukunimesi.',
  'form.register.address.error': 'Kirjoita vielä osoite.',
  'form.register.zipcode.error': 'Kirjoita vielä postinumero.',
  'form.register.city.error': 'Kirjoita vielä kaupunki.',
  'form.register.password.error': 'Kirjoita uusi salasanasi.',
  'form.register.password-confirm.error': 'Kirjoita tähän uusi salasanasi uudelleen.',
  'form.register.password-equality.error': 'Salasanat eivät täsmää. Kokeile kirjoittaa uudelleen.',

  'form.edit-profile.firstname.error': 'Kirjoita vielä etunimesi.',
  'form.edit-profile.lastname.error': 'Kirjoita vielä sukunimesi.',
  'form.edit-profile.address.error': 'Kirjoita vielä osoite.',
  'form.edit-profile.zipcode.error': 'Kirjoita vielä postinumero.',
  'form.edit-profile.city.error': 'Kirjoita vielä kaupunki.',

  'form.create-user.error': 'Antamallasi sähköpostiosoitteella on jo lisätty käyttäjä.',
  'form.create-user.team.error': 'Valitse tiimi, johon lisäät käyttäjän.',
  'form.create-user.email.error': 'Tämä ei taida olla toimiva sähköpostiosoite. Kokeile kirjoittaa uudelleen.',
  'form.delete-user.confirm': 'Haluatko varmasti poistaa kokonaan käyttäjän?',
  'form.delete-team.confirm': 'Haluatko varmasti poistaa kokonaan tiimin?',
  'form.delete-region.confirm': 'Haluatko varmasti poistaa kokonaan alueen?',
  'form.delete-channel.confirm': 'Haluatko varmasti poistaa kokonaan myyntikanavan?',

  'form.transfer-user.title.0': 'Käyttäjän',
  'form.transfer-user.title.1': 'siirto ja roolin valinta',
  'form.transfer-user.confirm': 'Haluatko varmasti siirtää käyttäjän?',

  'form.create-team.error': 'Tämän niminen tiimi on jo lisätty.',
  'form.create-team.error.user': 'Antamallasi sähköpostiosoitteella on jo lisätty käyttäjä.',
  'form.create-team.channel.error': 'Valitse jälleenmyyjä, jolle lisäät tiimin.',
  'form.create-team.team.error': 'Et vielä kirjoittanut tiimille nimeä.',
  'form.create-team.email.error': 'Syötä vielä tiimiesimiehen sähköpostiosoite.',

  'form.create-channel.error': 'Tämän niminen jälleenmyyjä on jo lisätty.',
  'form.create-channel.error.user': 'Antamallasi sähköpostiosoitteella on jo lisätty käyttäjä.',
  'form.create-channel.channel.error': 'Kirjoita jälleenmyyjän nimi.',
  'form.create-channel.email.error': 'Syötä vielä myyntijohtajan sähköpostiosoite.',

  'form.create-region.error': 'Tämän niminen alue on jo lisätty.',
  'form.create-region.error.user': 'Antamallasi sähköpostiosoitteella on jo lisätty käyttäjä.',
  'form.create-region.region.error': 'Kirjoita alueen nimi.',
  'form.create-region.channel.error': 'Valitse jälleenmyyjä.',
  'form.create-region.email.error': 'Syötä vielä aluepäällikön sähköpostiosoite.',

  'form.transactions-export.channel.error': 'Valitse jälleenmyyjä.',

  'form.edit.campaign.channel.error': 'Valitse kumppani',
  'form.edit.campaign.bonus.error': 'Syötä bonusprosentti välillä 0-100',
  'form.edit.campaign.startDate.error': 'Valitse aloituspäivämäärä',
  'form.edit.campaign.endDate.error': 'Valitse lopetuspäivämäärä',
  'form.date.range.error': 'Tarkista aloitus- ja lopetuspäivämäärät.',
  'form.campaign.exists.error':
    'Palkinto-ohjelma valitulle kumpppanille ja päivämäärille on jo olemassa. Tarkista päällekkäisyydet.',

  'form.no.cancel': 'Tätä toimintoa ei voi perua.',
};

export default json_fi;



// WEBPACK FOOTER //
// ./src/locale/locale_fi.js